import React, { useState } from 'react';
import { Mail, MapPin, Send, Instagram, MessageCircle } from 'lucide-react';
import { TELEGRAM_URL } from '../data/mock';
import { sendContact } from '../lib/api';
import CaliLetters from '../components/CaliLetters';

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await sendContact(form); } catch { /* ignore */ }
    setSent(true);
  };

  return (
    <div className="pt-[74px]">
      <section className="relative border-b border-white/10">
        <div className="absolute inset-0 smoke-red opacity-50" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14 text-center">
          <h1 className="font-anton text-4xl lg:text-6xl uppercase">
            <CaliLetters text="KONTAKT" />
          </h1>
          <p className="text-white/60 mt-3">Masz pytania? Najszybciej odpowiemy na Telegramie.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-anton text-2xl uppercase mb-6">
            <CaliLetters text="DANE KONTAKTOWE" />
          </h2>
          <div className="space-y-4">
            {[{ i: Mail, t: 'E-mail', v: 'kontakt@caliboyz.nl' }, { i: MapPin, t: 'Adres', v: 'Cali Boyz Street 420, 00-420 High City, PL' }].map((c, i) => (
              <div key={i} className="flex items-center gap-4 cb-panel rounded-xl border border-white/10 p-4">
                <div className="h-11 w-11 rounded-full border border-[#a6e22e]/50 grid place-items-center text-[#a6e22e]"><c.i size={20} /></div>
                <div>
                  <p className="text-white/50 text-xs uppercase">{c.t}</p>
                  <p className="font-semibold">{c.v}</p>
                </div>
              </div>
            ))}
          </div>
          <a href={TELEGRAM_URL} target="_blank" rel="noreferrer" className="btn-green w-full py-3.5 mt-6 flex items-center justify-center gap-2"><Send size={18} /> Napisz na Telegramie</a>
          <div className="flex gap-3 mt-4">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex-1 btn-ghost-red py-3 flex items-center justify-center gap-2"><Instagram size={17} /> Instagram</a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="flex-1 btn-ghost-red py-3 flex items-center justify-center gap-2"><MessageCircle size={17} /> TikTok</a>
          </div>
        </div>

        <div className="cb-panel rounded-2xl border border-white/10 p-6 lg:p-8">
          <h2 className="font-anton text-2xl uppercase mb-6">
            <CaliLetters text="NAPISZ DO NAS" />
          </h2>
          {sent ? (
            <div className="text-center py-10">
              <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-[#a6e22e]/20 grid place-items-center text-[#a6e22e]"><Send size={24} /></div>
              <p className="font-semibold">Dziękujemy! Wiadomość wysłana.</p>
              <p className="text-white/50 text-sm mt-1">Odezwiemy się najszybciej jak to możliwe.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Imię" className="w-full rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e] transition" />
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="E-mail" className="w-full rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e] transition" />
              <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Twoja wiadomość" className="w-full rounded-xl bg-black/60 border border-white/15 px-4 py-3 text-sm outline-none focus:border-[#a6e22e] transition resize-none" />
              <button className="btn-green w-full py-3.5">Wyślij wiadomość</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default Contact;
